import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        api.post("/auth/google-session", { session_id: sessionId })
            .then(({ data }) => {
                setUser(data);
                navigate("/", { replace: true, state: { user: data } });
            })
            .catch(() => navigate("/login", { replace: true }));
    }, [navigate, setUser]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
            <Loader2 className="w-6 h-6 animate-spin text-[var(--ok-accent)]" />
        </div>
    );
}
